import { NAVBAR_ID } from 'components/constants/Constants';
import { useState, useEffect } from 'react';

export default function useNavbarHeight() {
  const [navHeight, setNavHeight] = useState<number>(0);

  useEffect(() => {
    const navBar = document.getElementById(NAVBAR_ID);

    const height = navBar?.offsetHeight ?? 0;
    //we are using + 15 here instead of 16 because for smaller screens
    // the height of the nav might be like 77.6 and round to 78,
    //that will cause the stivky to trigger when the page loads
    //and thats not what we want
    setNavHeight(height + 15);
  }, [setNavHeight]);

  return navHeight;
}
